@if(pageService.viewDroplistItems.length){
<div class='delivery-engagements-views-part'>
	@if(pageService.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='pageService.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='pageService.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort'
		[groupSortValues]='{"Events":1, "Curriculum":2, "Course Progress":3, "Evaluation":4, }'
		style='display:inline-block'>
	</droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (pageService.viewId.AllEvents) {
	<acc-events-view-part></acc-events-view-part>
	}
	@case (pageService.viewId.Sessions) {
	<acc-sessions-view-part></acc-sessions-view-part>
	}
	@case (pageService.viewId.Topics) {
	<acc-topics-view-part></acc-topics-view-part>
	}
	@case (pageService.viewId.TopicSpecialists) {
	<acc-topic-specialists-view-part></acc-topic-specialists-view-part>
	}
	@case (pageService.viewId.SurveysBySesssion) {
	<acc-surveys-by-session-view-part></acc-surveys-by-session-view-part>
	}
	@case (pageService.viewId.SurveysByTopic) {
	<acc-surveys-by-topic-view-part></acc-surveys-by-topic-view-part>
	}
	@case (pageService.viewId.SurveysBySpecialist) {
	<acc-surveys-by-specialist-view-part></acc-surveys-by-specialist-view-part>
	}
	@case (pageService.viewId.Enrollments) {
	<acc-enrollments-view-part></acc-enrollments-view-part>
	}
	@case (pageService.viewId.ProgressBySection) {
	<acc-progress-by-section-view-part></acc-progress-by-section-view-part>
	}
	@case (pageService.viewId.FinalPresentation) {
	<acc-final-presentation-view-part></acc-final-presentation-view-part>
	}
	@case (pageService.viewId.Awards) {
	<acc-awards-view-part></acc-awards-view-part>
	}
	@case (pageService.viewId.Graduation) {
	<acc-graduation-view-part></acc-graduation-view-part>
	}
	}
	}

</div>
}